import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxBulkRequestValidationV2Params,
  IIndirectTaxBulkRequestValidationV2Response,
} from './types';

export async function requestIndirectTaxRegistrationsValidationBulk(
  params: IIndirectTaxBulkRequestValidationV2Params
): Promise<{
  success: boolean;
  data?: IIndirectTaxBulkRequestValidationV2Response;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/registrations-v2/bulk/request-validation',
      { method: 'POST', body: params },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to request validation',
      };
    }

    const data: IIndirectTaxBulkRequestValidationV2Response =
      await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to request validation';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
